
    import { computed, defineComponent, onBeforeMount, ref } from 'vue'

    import { useSweetAlert } from '@/common/composables/sweet-alert'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useGdprStore } from '@/app/stores/gdpr'
    import { useHot17Store } from '@/app/stores/hot-17'
    import { useGtag } from '@/common/composables/libs/gtag'
    import { useHeadful } from '@/common/composables/libs/headful'
    import { useI18n } from 'vue-i18n-composable'

    export default defineComponent({
        setup () {
            const gtag = useGtag()
            const headful = useHeadful()
            const i18n = useI18n()

            const gdprStore = useGdprStore()
            const hot17Store = useHot17Store()
            const { showToast } = useSweetAlert()

            const votes = ref<Array<number>>([])

            const alreadyVoted = computed(() => hot17Store.alreadyVoted)
            const entries = computed(() => hot17Store.entries)
            const isEnabled = computed(() => hot17Store.isEnabled)
            const sortedEntries = computed(() => hot17Store.sortedEntries)
            const votingPhase = computed(() => hot17Store.data.voting_phase)

            const gdprAccepted = computed(() => gdprStore.accepted)

            const acceptGdpr = (): void => {
                gdprStore.accept()
                gtag.optIn()
            }

            const reset = async (): Promise<void> => {
                if (!await hot17Store.reset()) {
                    await showToast(i18n.t('hot-17.errors.reset').toString(), 'error')
                }
            }

            const vote = async (): Promise<void> => {
                if (!await hot17Store.vote(votes.value)) {
                    await showToast(i18n.t('hot-17.errors.vote').toString(), 'error')
                }
            }

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().reset()

                headful({
                    title: `${i18n.t('nav.schedule.hot-17')} | ${i18n.t('meta.title')}`
                })

                await hot17Store.load()
                votes.value = hot17Store.userVotes
            })

            return {
                alreadyVoted,
                entries,
                gdprAccepted,
                isEnabled,
                sortedEntries,
                votes,
                votingPhase,
                acceptGdpr,
                reset,
                vote
            }
        }
    })
